import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	noFieldsAvailable: {
		id: 'project-create-importer-upload-flow.mapping-screen.mapping-table.column-header.no-fields-available.no-fields-available',
		defaultMessage: 'No fields available...',
		description: 'Message shown if no fields match the specified search term',
	},
});
